import type { CSSProperties } from 'react'

/** Mode-panel / sidebar leaf wash. Matches Inbox + interior primary rail. */
export const WS_NAV_PRIMARY_COLOR = 'hsl(var(--primary))'

/**
 * Set on `.ws-nav-section` so `.ws-nav-item` hover/active use color-mix.
 * Never pair `ws-nav-item` with `hover:bg-sidebar-accent` (white/gray wash).
 */
export function wsNavSectionStyle(color?: string | null): CSSProperties {
  return { '--ws-color': color?.trim() || WS_NAV_PRIMARY_COLOR } as CSSProperties
}
